// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"92d6a6f9","938":"1ad192d7"}[chunkId] + ".chunk.js";
};